import React from 'react';
import { HeadingText, ActionText } from './styledComponents';

type Props = {
  titleText?: string;
  actionText: string;
};

const ModalHeading = ({ titleText, actionText }: Props) => (
  <div>
    {titleText && <HeadingText>{titleText}</HeadingText>}
    <ActionText>{actionText}</ActionText>
  </div>
);

export default ModalHeading;
